<template>
    <router-view></router-view>
    <div class="dropdown" id="userMenu">
        <a class="nav-link text-white" data-toggle="dropdown" href="#">
          <i class="fas fa-user mr-1"></i> {{ user ? user.fullname : "" }}
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
            <router-link to="/admin" class="dropdown-item"  >
                <i class="fa-solid fa-gears mr-2"></i> Trang quản trị
            </router-link>
            <div class="dropdown-divider"></div>
            <button class="dropdown-item" data-toggle="modal" data-target="#changePassModal">
                <i class="fas fa-key mr-2"></i> Đổi mật khẩu
            </button>
            <div class="dropdown-divider"></div>
            <button class="dropdown-item" data-toggle="modal" data-target="#changeProfileModal">
              <i class="fas fa-circle-info mr-2"></i> Thông tin cá nhân
            </button>
            <div class="dropdown-divider"></div>
            <button class="dropdown-item" >
                <i class="fas fa-sign-out-alt mr-2"></i> Đăng xuất
            </button>
        </div>
    </div>
    <!-- <div class="btn-group" id="userMenu">
        <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{ user ? user.fullname : "" }}
        </button>
        <div class="dropdown-menu dropdown-menu-right">
            <button class="dropdown-item" type="button">Thông tin cá nhân</button>
            <router-link to="/" class="dropdown-item" type="button">Trang quản trị</router-link>
            <button class="dropdown-item" type="button">Đăng xuất</button>
        </div>
    </div> -->
    <TheChangePassword/>
    <TheChangeProfile/>
</template>
  
<script>
  import TheChangePassword from "@/components/authentication/TheChangePassword.vue";
  import TheChangeProfile from "@/components/authentication/TheChangeProfile.vue";
  import { mapActions } from 'vuex'
  export default {
    name: "TheUserLayout",
    components: {
      TheChangePassword,
      TheChangeProfile
    },
    data() {
      return {
        user: null
      }
    },
    methods: {
      ...mapActions('authentication', ['logout']),
      setup() {
        this.user = JSON.parse(localStorage.getItem('login_info'));
      },
    },
    mounted() {
      this.setup();
    },
    created() {
     
    }
  };
</script>
  
  <style>
    @import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,400i,700&display=fallback");
  
    body {
      /* background: #262a2b !important; */
      background: #1f1e30 url('@/assets/bg.png') no-repeat center bottom;
      background-size: cover;
    }
    #userMenu {
      position: fixed;
      top: 1rem;
      right: 1rem;
    }
  </style>
  